// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"7678": "85fb2b9d","8383": "81850193","9537": "a91e29e7",}[chunkId] + ".css"
}